module.exports = __webpack_public_path__ + "img/Piece-18-3-mobile.032b217f.png";